import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router";
import { Row, Container, Col, Button, Tabs, Tab } from "react-bootstrap";
import { Box, AddressBox, DefaultAddressText } from "./styles";
import {
  deleteAddress,
  addAddress,
  editAddresses,
  getAddress,
  getAddresses,
} from "../../components/AddressComponent/services/addressService";
import notify from "../../components/UI/toast";
import { LoaderSmall } from "../../components/Loader";
import { useUserData } from "../../hooks/UserContext";
import AddressComponent from "../../components/AddressComponent";
import ModalApp from "../../components/ModalApp";
import ErrorBoundary from "../../components/ErrorBoundary";
import Footer from "../../components/Footer";

import { useSelector, useDispatch } from "react-redux";
import { getCart, setPaymentMethod } from "../../Redux/cartSlice";
import { swalCustom } from "../../utils/functions";
import useLocalStorage from "hooks/useLocalStorage";
import { useApp } from "../../contexts/AppContext";
import { trackClick, trackCheckoutAddressEvent } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";

export default function ListAddressesPage() {
  const navigate = useNavigate();
  const { whitelabel } = useApp();

  const [address, setAddress] = useState({});
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("dinheiro");
  const {
    user,
    changeAddress,
    addressesData,
    addressShipping,
    setUpdateAddresses,
    mainAddress,
    setMainAddress,
  } = useUserData();

  const [showPaymentWarning, setShowPaymentWarning] = useState(false);
  const dispatch = useDispatch();
  const { cart, loading } = useSelector((state) => state.cartSlice);

  const isSafraAddress = (addr) => addr?.fixed === 1;

  const safraAddressMessage =
    "Este é seu endereço de cadastro no Safra. Para alterá-lo é necessário entrar em contato com o banco.";

  function deletarEndereco(addressInfo) {
    if (isSafraAddress(addressInfo)) {
      notify(safraAddressMessage, "info");
      return;
    }
    trackCheckoutAddressEvent({ title: "excluir" });

    const addressUuid = addressInfo?.uuid;
    if (!addressUuid) return;
    swalCustom
      .fire({
        html: '<p class="fw-light fs-5 mb-0">Deseja excluir este endereço?</p>',
        showCancelButton: true,
        confirmButtonText: "EXCLUIR",
        cancelButtonText: "CANCELAR",
        icon: "info",
        iconColor: "rgba(0, 38, 217, 1)",
      })
      .then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          var message = "";
          var type = "success";
          deleteAddress(user.cpf, addressUuid)
            .then((response) => {
              message = response.message;
            })
            .catch((error) => {
              message = error.message;
              type = "error";
            })
            .finally(() => {
              notify(message, type);
              setUpdateAddresses(new Date());
              refreshResume();
            });
        }
      });
  }

  async function handleEndereco(address) {
    let result = null;
    address["customerUuid"] = user.uuid;

    if (address.main === true || address.main === 1) {
      try {
        const addresses = await getAddresses(user.cpf);

        const currentMain = addresses.find(
          (addr) => addr.main === true || addr.main === 1,
        );

        if (currentMain && currentMain.uuid !== address.uuid) {
          const updateMainResult = await editAddresses({
            ...currentMain,
            uuid: currentMain.uuid,
            customerUuid: user.uuid,
            main: "0",
          });

          if (!updateMainResult.status) {
            notify("Erro ao remover o endereço principal anterior", "error");
            return;
          }
        }

        if (address.uuid) {
          result = await editAddresses(user.cpf, address);
        } else {
          result = await addAddress(user.cpf, address);
        }

        if (!result.status) {
          notify(result.data.message, "error");
          return;
        }

        notify(result.data.message, "success");
        setUpdateAddresses(new Date());
        refreshResume();
        
      } catch (error) {
        console.error("Erro ao atualizar endereço principal:", error);
        notify("Erro ao atualizar endereço", "error");
      } finally {
        return;
      }
    }

    if (address.uuid) {
      result = await editAddresses(user.cpf, address);
    } else {
      result = await addAddress(user.cpf, address);
    }

    console.log("Resultado da operação:", result);

    if (!result.status) {
      notify(result.data.message, "error");
      return;
    }

    notify(result.data.message, "success");
    setUpdateAddresses(new Date());
    refreshResume();
  }

  function editarEndereco(selectedAddress) {
    if (isSafraAddress(selectedAddress)) {
      notify(safraAddressMessage, "info");
      return;
    }
    trackCheckoutAddressEvent({ title: "editar" });
    setAddress(selectedAddress);
    setOpen(true);
  }

  function adicionarEndereco() {
    trackCheckoutAddressEvent({ title: "adicionar-novo-endereco" });
    setAddress({});
    setOpen(true);
  }

  const handleAddressSelect = (address, position) => {
    trackCheckoutAddressEvent({ title: `selecionou-endereco-${position}` });
    setMainAddress(address);
  };

  const handleSelectClick = () => {
    trackCheckoutAddressEvent({ title: "selecionar" });
    handleSelectMainAddress();
  };

  function refreshResume() {
    setOpen(false);
  }

  const handleCheckout = () => {
    // if (cart.warning) {
    //   return;
    // }
    if (disable()) {
      return;
    }

    if (!Object.keys(addressShipping).length) {
      notify("Selecione o endereço de entrega!", "error");
      return;
    }
    navigate("/loja/orderresumepag/");
  };

  const triggerWarning = (reason) => {
    notify(reason, "error");
  };
  const handleAddress = (uuid) => {
    //dispatch(setLoading({value: true}))
    let address_selected = addressesData.find((a) => a.uuid === uuid);
    if (address_selected) {
      changeAddress(address_selected);
      refreshResume();
    }
  };

  const handleDefaultChecked = (address, index) => {
    //return true;
    // !Object.keys(addressShipping).length
    //   ? index === 0 && true
    //   : addressShipping.uuid === address.uuid && true;

    if (Object.keys(addressShipping).length === 0) {
      return index === 0;
    } else {
      return addressShipping.uuid === address.uuid;
    }
  };

  // useEffect(() => {
  //     const cpf = user.cpf
  //     const cep = addressShipping.cep
  //     if(cpf && cep)
  //         dispatch(getCart({cpf, cep}))
  //         .unwrap()
  //         .then((payload) => {
  //             if(payload.warning) {
  //                 for (const val of payload.warning) {
  //                     triggerWarning(reasons[val.reason])
  //                     break;
  //                 }
  //             }
  //         })
  //   }, [user,addressShipping])

  const handlePaymentMethod = (type) => {
    const textType = type ? "dinheiro" : "pontos";

    dispatch(setPaymentMethod({ value: textType }));
    setTab(textType);

    if (textType === "pontos" && cart.minimum_payments.WL > user.balance) {
      setShowPaymentWarning(true); // Mostra o aviso se não houver pontos suficientes
      return;
    } else {
      setShowPaymentWarning(false); // Esconde o aviso se houver pontos suficientes
    }
  };

  const disable = () => {
    if (
      cart?.minimum_payments &&
      cart?.minimum_payments?.WL &&
      tab === "pontos"
    ) {
      if (cart.minimum_payments.WL > user.balance) {
        return true;
      }
    }
    return false;
  };

  if (loading) return <LoaderSmall />;

  if (!addressesData.length) {
    window.location.assign("/loja");
  }

  function handleSelectMainAddress() {
    if (!mainAddress || !mainAddress.uuid) {
      notify("Selecione um endereço antes de continuar!", "error");
      return;
    }

    const mappedAddress = {
      ...mainAddress,
      address_line1: mainAddress.streetName,
      address_line2: mainAddress.neighborhood,
      address_line3: mainAddress.complement,
      cep: mainAddress.zipCode,
    };

    changeAddress(mappedAddress);
    navigate("/loja/ordersummary");
  }

  return (
    <>
      <ModalApp
        show={open}
        handleModal={() => setOpen(false)}
        contentClassName="modal-address"
      >
        <AddressComponent
          onConfirm={handleEndereco}
          onCancel={() => setOpen(false)}
          address={address}
        />
      </ModalApp>
      <ErrorBoundary>
        <div className="wl-page mt-4">
          <Box className="py-3">
            <Row className="m-3">
              <DefaultAddressText className="font-wl-500 text-mg">
                Endereço padrão
              </DefaultAddressText>
              <Col>
                {addressesData ? (
                  addressesData?.map(
                    (address, index) =>
                      (address.main === true || address.main === 1) && (
                        <AddressBox
                          key={address.uuid}
                          main={
                            mainAddress && address.uuid === mainAddress.uuid
                          }
                        >
                          <Row>
                            <Col className="col-1 p-4 d-flex align-items-center justify-content-center">
                              <input
                                type="radio"
                                name="selectMainAddress"
                                className="selectMainAddressRadio"
                                checked={
                                  mainAddress &&
                                  address.uuid === mainAddress.uuid
                                }
                                onChange={() => handleAddressSelect(address, index + 1)}
                              />
                            </Col>
                            <Col>
                              <p className="mt-2 mb-1 color-wl font-wl-600">
                                {address.label}
                              </p>

                              <div>
                                <p className="mb-0 color-wl text-sm">
                                  {address.streetName}, {address.number}{" "}
                                </p>
                                <p className="mb-0 color-wl text-sm">
                                  {address.neighborhood},{" "}
                                  {address.complement}{" "}
                                </p>
                                <p className="mb-0 color-wl text-sm">
                                  {`${address.city}, ${address.state} - ${address.zipCode}`}
                                </p>
                              </div>
                              {isSafraAddress(address) && (
                                <div className="mt-3">
                                  <p className="text-xs mb-1 text-text_primary_color italic">
                                    {safraAddressMessage}
                                  </p>
                                </div>
                              )}
                            </Col>
                            {!isSafraAddress(address) && (
                              <div className="my-2 d-flex align-items-center justify-content-center">
                                <div className="d-flex align-items-center gap-3 font-wl-700">
                                  <a
                                    className="confirm text-xs"
                                    style={{
                                      color: whitelabel?.theme?.text_primary_color,
                                    }}
                                    onClick={() => {
                                      editarEndereco(address);
                                    }}
                                  >
                                    Editar
                                  </a>
                                  <a
                                    className="link-cancel-wl text-xs"
                                    style={{ color: "#96143C" }}
                                    onClick={() => {
                                      deletarEndereco(address);
                                    }}
                                  >
                                    Excluir
                                  </a>
                                </div>
                              </div>
                            )}
                          </Row>
                        </AddressBox>
                      ),
                  )
                ) : (
                  <div>
                    <p className="mb-0 text-sm ">
                      {" "}
                      Cadastre o endereço que deseja receber seu <br /> pedido
                      para seguir com a compra.{" "}
                    </p>
                    <div className="mt-4">
                      <a
                        className="link-default-wl"
                        onClick={() => adicionarEndereco()}
                        style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: 700 }}
                      >
                        Adicionar Endereço
                      </a>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
            <Row className="m-3">
              <DefaultAddressText className="font-wl-500 text-mg mb-4">
                Outros endereços
              </DefaultAddressText>

              <Col>
                {addressesData ? (
                  addressesData?.map(
                    (address, index) =>
                      !address.main && (
                        <AddressBox
                          key={address.uuid}
                          main={
                            mainAddress && address.uuid === mainAddress.uuid
                          }
                        >
                          <Row>
                            <Col className="col-1 p-4 d-flex align-items-center justify-content-center">
                              <input
                                type="radio"
                                name="selectMainAddress"
                                className="selectMainAddressRadio"
                                checked={
                                  mainAddress &&
                                  address.uuid === mainAddress.uuid
                                }
                                onChange={() => handleAddressSelect(address, index + 1)}
                              />
                            </Col>
                            <Col>
                              <p className="mt-2 mb-1 color-wl font-wl-600">
                                {address.label}
                              </p>

                              <div style={{ color: "#050922" }}>
                                <p className="mb-0 color-wl text-sm">
                                  {address.streetName}, {address.number}{" "}
                                </p>
                                <p className="mb-0 color-wl text-sm">
                                  {address.neighborhood},{" "}
                                  {address.complement}{" "}
                                </p>
                                <p className="mb-0 color-wl text-sm">
                                  {`${address.city}, ${address.state} - ${address.zipCode}`}
                                </p>
                              </div>
                              {isSafraAddress(address) && (
                                <div className="mt-3">
                                  <p className="text-xs mb-1 text-text_primary_color italic">
                                    {safraAddressMessage}
                                  </p>
                                </div>
                              )}
                            </Col>
                            {!isSafraAddress(address) && (
                              <div className="my-2 d-flex align-items-center justify-content-center">
                                <div className="d-flex align-items-center gap-3 font-wl-700">
                                  <a
                                    className="confirm text-xs"
                                    style={{
                                      color: whitelabel?.theme?.text_primary_color,
                                    }}
                                    onClick={() => {
                                      editarEndereco(address);
                                    }}
                                  >
                                    Editar
                                  </a>
                                  <a
                                    className="link-cancel-wl text-xs"
                                    style={{ color: "#96143C" }}
                                    onClick={() => {
                                      deletarEndereco(address);
                                    }}
                                  >
                                    Excluir
                                  </a>
                                </div>
                              </div>
                            )}
                          </Row>
                        </AddressBox>
                      ),
                  )
                ) : (
                  <div>
                    <p className="mb-0 text-sm ">
                      {" "}
                      Cadastre o endereço que deseja receber seu <br /> pedido
                      para seguir com a compra.{" "}
                    </p>
                    <div className="mt-4">
                      <a
                        className="link-default-wl"
                        onClick={() => adicionarEndereco()}
                        style={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: 700 }}
                      >
                        Adicionar Endereço
                      </a>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </Box>
          <Footer orderResume={true}>
            <Button
              type="button"
              className={`mb-2 btn-default-wl ${
                !addressesData.length || (disable() && "disable")
              }`}
              style={{ fontSize: "12px", width: 187 }}
              onClick={handleSelectClick}
            >
              SELECIONAR
            </Button>
            <Button
              type="button"
              className={`btn-outline-wl`}
              style={{ fontSize: "12px", width: 187 }}
              onClick={() => {
                trackClick({
                  title: "adicionar-endereco",
                  contentType: "checkout",
                  screenName: "carrinho",
                  tagId: tagIdFromLegacySuffix("16"),
                });
                adicionarEndereco();
              }}
            >
              ADICIONAR ENDEREÇO
            </Button>
          </Footer>
        </div>
      </ErrorBoundary>
    </>
  );
}
